import actionTypes from 'constants/actionTypes'
import single from './single'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import reduce from 'lodash/reduce'
import { isHardFail } from 'lib/action'

interface NodeInput {
  id?: string
  [key: string]: unknown
}

type NodesAllState = Record<string, ReturnType<typeof single>>

interface NodesAllAction {
  type?: string
  payload?: {
    id?: string
    ids?: string[]
    data?: {
      id?: string
      ids?: string[]
      nodes?: NodeInput[]
    }
  }
  previousPayload?: {
    id?: string
    ids?: string[]
  }
}


const all = (state: NodesAllState = {}, action: NodesAllAction): NodesAllState => {
  const actionType = action.type ?? ''
  switch (true) {
    case actionType === actionTypes.NODES.ONE.CREATE.FAIL: {
      const id = action.previousPayload?.id
      if (!id) return state
      if (isHardFail(action)) {
        const updated = cloneDeep(state)
        delete updated[id]
        return updated
      }
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case [
      actionTypes.NODES.ONE.CREATE.REQUEST,
      actionTypes.NODES.ONE.CREATE.RECEIVE,
      actionTypes.NODES.ONE.CREATE.NOTIFY,
      actionTypes.NODES.ONE.START_EDITING,
      actionTypes.NODES.ONE.STOP_EDITING,
      actionTypes.NODES.ONE.EDIT.REQUEST,
      actionTypes.NODES.ONE.EDIT.RECEIVE,
      actionTypes.NODES.ONE.EDIT.NOTIFY,
      actionTypes.NODES.ONE.EDIT.FAIL,
      actionTypes.NODES.ONE.DELETE.REQUEST,
      actionTypes.NODES.ONE.DELETE.RECEIVE,
      actionTypes.NODES.ONE.DELETE.NOTIFY,
      actionTypes.NODES.ONE.DELETE.FAIL
    ].includes(actionType): {
      const id = action.payload?.id || action.payload?.data?.id || action.previousPayload?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case [
      actionTypes.NODES.MULTI.DELETE.REQUEST,
      actionTypes.NODES.MULTI.DELETE.RECEIVE,
      actionTypes.NODES.MULTI.DELETE.NOTIFY,
      actionTypes.NODES.MULTI.DELETE.FAIL
    ].includes(actionType): {
      const ids = action.payload?.ids || action.payload?.data?.ids || action.previousPayload?.ids
      return reduce(ids ?? [], (ns: NodesAllState, id: string) => {
        return defaultsDeep(
          {
            [id]: single(state[id], action, { id })
          },
          ns
        )
      }, state)
    }
    case actionType === actionTypes.GRAPH.GET_NEIGHBORHOOD.RECEIVE:
      return reduce(action.payload?.data?.nodes ?? [], (ns: NodesAllState, node: NodeInput) => {
        const nodeId = node.id
        if (!nodeId) return ns
        return defaultsDeep(
          {
            [nodeId]: single(state[nodeId], action, node)
          },
          ns
        )
      }, state)
    default:
      return state
  }
}

export default all
